import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=132de3df&scoped=true"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132de3df",
  null
  
)

export default component.exports